










































import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { StandardOption } from "../../system/selectors/mixins";
import { Department } from "../../../domain/department";
import { DepartmentSelectableMixin } from "./mixins";

@Component
export default class DepartmentComboBoxSelector extends Mixins(DepartmentSelectableMixin) {
  @Prop({ default: false })
  isDisabled: boolean;

  $refs!: {
    input: HTMLInputElement;
    ul: HTMLUListElement;
  };

  data(): any {
    return {
      isExpanded: false,
      selected: null,
    };
  }
  isExpanded: boolean;
  selected: Department;
  expandedHidingTimer: number;

  mounted() {
    this.updateSelectedWithSource();
  }

  get dropDownOptions(): StandardOption<any>[] {
    return Enumerable.from([ new StandardOption<any>("未指定", null) ])
      .concat(!this.departmentOptions ? [] : this.departmentOptions)
      .toArray();
  }

  get selectedListIndex(): number {
    return this.dropDownOptions.findIndex(v => this.areIdsEqual(v.value, this.selected));
  }

  get maxCount(): number {
    return Math.min(this.dropDownOptions.length, 10);
  }

  private showExpand() {
    clearTimeout(this.expandedHidingTimer);
    this.isExpanded = true;
  }

  private hideExpanded() {
    this.expandedHidingTimer = setTimeout(() => this.isExpanded = false);
  }

  private selectPreviousOption() {
    const selectedIndex = this.selectedListIndex;
    if (selectedIndex < 1) { return; }
    const previousIndex = selectedIndex - 1;
    if (this.dropDownOptions.length >= previousIndex) {
      this.editingSource = this.dropDownOptions[previousIndex].value;
    }
  }

  private updateSourceWithSelected() {
    this.editingSource = this.selected;
  }

  private adjustScrollTop(): void {
    const selectedIndex = this.selectedListIndex;
    if (selectedIndex < 0) { return; }
    if (!this.$refs.ul) { return; }
    const itemClientHeight = this.$refs.ul.scrollHeight / this.dropDownOptions.length;
    // 選択項目を真ん中に表示する（選択項目より小さい値が無ければ１番下に、大きい値が無ければ１番上に表示）
    this.$refs.ul.scrollTop = selectedIndex === (this.dropDownOptions.length - 1) 
      ? this.$refs.ul.scrollHeight - itemClientHeight
      : (itemClientHeight * (selectedIndex - (Math.round(this.maxCount / 2) - 1)));
  }

  private selectNextOption() {
    const selectedIndex = this.selectedListIndex;
    const nextIndex = selectedIndex + 1;
    if (this.dropDownOptions.length === nextIndex) { return; }
    if (this.dropDownOptions.length > nextIndex) {
      this.editingSource = this.dropDownOptions[nextIndex].value;
    }
  }

  private focusInput() {
    if (this.$refs.input) {
      this.$refs.input.focus();
    }
  }

  private toggleExpand() {
    if (this.isExpanded) {
      this.hideExpanded();
    } else {
      this.showExpand();
    }
  }

  private focusUl() {
    if (this.$refs.ul) {
      this.$refs.ul.focus();
    }
    this.$nextTick(() => this.updateSelectedWithSource());
  }

  private updateSelectedWithSource() {
    if (!!this.editingSource) {
      this.selected = this.editingSource;
    } else if (this.dropDownOptions.length > 0) {
      this.selected = this.dropDownOptions[0].value;
    }
  }

  toString(option: StandardOption<Department>): string {
    return option
      ? option.label
      : "";
  }

  onInputBlur() {
    this.hideExpanded();
  }

  onInputClick() {
    this.toggleExpand();
  }

  onInputKeyDownArrowUp(event: KeyboardEvent) {
    event.stopPropagation();
    event.preventDefault();
  }

  onInputKeyDownArrowDown(event: KeyboardEvent) {
    event.stopPropagation();
    event.preventDefault();
  }

  onInputKeyupUp() {
    this.showExpand();
    this.$nextTick(() => this.focusUl());
  }

  onInputKeyupDown() {
    this.showExpand();
    this.$nextTick(() => this.focusUl());
  }

  onInputKeyupEnter() {
    if (this.$refs.input) {
      this.$refs.input.blur();
    }
  }

  onInputKeyupEsc() {
    this.hideExpanded();
  }

  onUlFocus() {
    this.showExpand();
  }

  onUlBlur() {
    this.hideExpanded();
  }

  onUlKeyDownArrowUp(event: KeyboardEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.selectPreviousOption();
    this.adjustScrollTop();
  }

  onUlKeyDownArrowDown(event: KeyboardEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.selectNextOption();
    this.adjustScrollTop();
  }

  onUlKeyupEnter() {
    this.updateSourceWithSelected();
    this.focusInput();
  }

  onUlKeyupEsc() {
    this.focusInput();
  }

  getListClassName(index: number): string {
    return this.selectedListIndex === index
      ? "list-selected"
      : "list-unselected";
  }

  onListClick(index: number) {
    this.selected = this.dropDownOptions[index].value;
    this.updateSourceWithSelected();
    this.focusInput();
  }

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: Department) {
    if (!this.areIdsEqual(this.selected, newValue)) {
      this.updateSelectedWithSource();
    }
  }

  @Watch("isExpanded")
  onIsExpandedUpdated(newValue: boolean) {
    if (!newValue) { return; }
    this.$nextTick(() => {
      this.adjustScrollTop();
    });
  }

  @Watch("dropDownOptions")
  onDropDownOptionsUpdated() {
    this.$nextTick(() => {
      this.adjustScrollTop();
    });
  }
}
